import * as React from "react";
import { Stepper, Step, StepLabel, Box, Typography } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import StepConnector from "@mui/material/StepConnector";

const steps = ["    ", "Initial", "Managed", "Measured", "Optimized"];
const STEP_COLORS = ["#babdc1", "#d32f2f", "#fbc02d", "#2e7d32", "#1976d2"];

// const labelSx = {
//   "& .MuiStepLabel-label": {
//     fontSize: 12,
//     fontWeight: 400,
//     textAlign: "center",
//     width: "64px",
//     marginTop: "-52px",
//   },
// };
const fill = keyframes`
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
`;

export const MultiColorConnector = styled(StepConnector)(({ theme }) => ({
  "&.MuiStepConnector-alternativeLabel": {
    top: 10,
    [theme.breakpoints.down("sm")]: {
      top: 18,
    },
  },
  [`& .MuiStepConnector-line`]: {
    height: 6,
    border: 0,
    borderRadius: 2,
    position: "relative",
    transformOrigin: "left",
    backgroundColor: "var(--connector-color)",
    animation: `${fill} 3.0s 1.0s ease forwards`,
    width: "var(--ml-connector-width, 25px)",
    margin: "0px 0px 0px -6px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "36px",
      margin: "-7px 0px 0px -6px",
    },
  },

  // "&.Mui-active .MuiStepConnector-line::after, &.Mui-completed .MuiStepConnector-line::after, &.MuiStepConnector-root":
  //   {
  //     content: '""',
  //     left: "calc(-50%+12px)  !important",
  //     right: "calc(50%+12px)  !important",
  //     position: "absolute",
  //     height:'2px',
  //     inset: 0,
  //     backgroundColor: "var(--connector-color)",
  //     transformOrigin: "left",
  //     animation: `${fill} 3.0s ease forwards`,
  //     width: "50px",
  //   },
   "&.Mui-active .MuiStepConnector-line::after, &.Mui-completed .MuiStepConnector-line::after":
    {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%",
      width: "100%",
      backgroundColor: "var(--connector-color)",
      transform: "scaleX(1)",
      transformOrigin: "left",
      transition: "transform 0.6s ease",
    },
  "& .MuiStepConnector-line::after": {
    transform: "scaleX(0)",
  },
}));
const ColorStepIcon = ({ icon, active, completed, showLabels, circleSize = 18, circleHeight = 16 }) => {
  const color = STEP_COLORS[icon - 1];
  return (
    <div
      style={{
        borderRadius: "50%",
        width: active ? 24 : 24,
        height: active ? 20 : 20,
        backgroundColor: active ? color : "white",
        display: "flex",
        border: `4px solid ${color}`,
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: 400,
        transition: "height 0.3s ease",
        marginTop: (icon === 1 && showLabels) ? "16px" : "0px",
        marginLeft:active?-3:-3
        // animation: `${fill} 3.0s ease forwards`
      }}
    />
  );
};

export default function MetroLineStepper({ score = 98, maturityLevel, mt = 5, showLabels = true, connectorWidth = "27px", circleSize = 18, circleHeight = 16 }) {
  const maxScore = 100;
  const stepScore = maxScore / 4;
  // const completedSteps = maturityLevel=="Optimized"?Math.floor(score / stepScore)+1:maturityLevel=="Initial"?1:Math.floor(score / stepScore);
  const completedSteps=steps.indexOf(maturityLevel);
  const BoundColorStepIcon = React.useCallback(
    (props) => <ColorStepIcon {...props} showLabels={showLabels} circleSize={circleSize} circleHeight={circleHeight} />,
    [showLabels, circleSize, circleHeight]
  );
  return (
    <Box sx={{ width: "100%", mt, "--ml-connector-width": connectorWidth }}>
      <Stepper
        alternativeLabel
        activeStep={completedSteps}
        connector={<MultiColorConnector />}
      >
        {steps.map((label, index) => (
          <Step
            key={label}
            completed={index < completedSteps}
            sx={{
              // "--connector-color": STEP_COLORS[index],
              "--connector-color": index <= completedSteps ?"#000000":"#f5f5f5",
            }}
          >
            {showLabels && (
              <Typography
                align="left"
                style={{
                  marginTop: "-22px",
                  fontSize: 10,
                  fontWeight: index === completedSteps ? 600 : 400,
                  textAlign: "center",
                  width: "40px",
                }}
              >
                {label}
              </Typography>
            )}
            <StepLabel
            StepIconComponent={BoundColorStepIcon}
            sx={{ marginTop: showLabels ? "6px" : "0px" }}>
              {/* <StepLabel StepIconComponent={ColorStepIcon} sx={labelSx}> */}
              {/* {label} */}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {/* Score */}
      {/* <Box sx={{ mt: 3 }}>
        {true && (
          <Typography
            sx={{
              fontSize: {
                xs: "2rem",
                sm: "2.25rem",
                md: "2.5rem",
                lg: "2.75rem",
                xl: "3rem",
                fontFamily: "Akkurat"
              },
              fontWeight: 400,
              color: STEP_COLORS[completedSteps],
              lineHeight: 1,
              mb: "15px",
            }}
          >
            {score}%
          </Typography>
        )}
      </Box> */}
    </Box>
  );
}